import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { App } from "./App/App";
import store from "./_store/store";
import * as serviceWorker from "./serviceWorker";
import { amplifyConfig } from "./_config/aws";

amplifyConfig();

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <App />
    </HashRouter>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
